module.exports = __webpack_public_path__ + "static/media/Desktop_School.93ea8d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewcc/Desktop_School.png
// module id = 101
// module chunks = 0